import React from 'react';

import { Button } from '@/components/ui/button';
import { useTheme } from '@/contexts/ThemeContext';

const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

const ThemeToggle: React.FC = () => {
  const { mode, colorScheme, toggleMode } = useTheme();

  const label =
    mode === 'system' ? `System (${colorScheme})` : capitalize(mode);

  return (
    <Button
      color='gray'
      hierarchy='link'
      size='sm'
      onClick={toggleMode}
      aria-label='Toggle theme'
      title='Toggle theme (Light → Dark → System)'
    >
      {label}
    </Button>
  );
};

export default ThemeToggle;
